import Helpers from '../modules/Helpers'

const breadcrumbs = {}

breadcrumbs.el = document.getElementById('breadcrumb')

breadcrumbs.set = (crumbs) => {
    breadcrumbs.clear()

    crumbs.forEach((crumb) => {
        const newCrumb = document.createElement('li')
        const link = document.createElement('a')
        link.href = crumb.href
        link.innerText = crumb.text
        newCrumb.appendChild(link)
        breadcrumbs.el.getElementsByTagName('ul')[0].appendChild(newCrumb)
    })
}

breadcrumbs.clear = () => {
    const crumbEls = Array.from(breadcrumbs.el.getElementsByTagName('li'))
    // ignore the first el (home link)
    crumbEls.shift()
    // delete the rest
    crumbEls.forEach(crumb => crumb.parentNode.removeChild(crumb))
}

export default breadcrumbs